//https://thor.paypad.com.ng/api/v3/ibile 
// "https://paycentre.paypad.com.ng/api/v3/ibile
export const Config = {
  apiUrl: "https://paycentre.paypad.com.ng/api/v3/ibile",
    // apiUrl: "https://thor.paypad.com.ng/api/v3/ibile",
  defaults: {
    paginator: {
      pageKey: "page",
      limitKey: "limit",
      searchKey: "search",
      limit: 10,
      startPage: 1,
    },
  },
};
